__webpack_require__.p = "/jamni_website/";